
import { Grid } from "@material-ui/core"
import moment from "moment";
import React from 'react'
import { useSelector } from "react-redux"
import { MuvInstructionsPopover } from '../MuvBookingPage/MuvInstructionsPopover'

// Currency symbol map
const currencySymbols = {
    USD: "$",
    CAD: "CA$",
    EUR: "€",
    GBP: "£",
    AUD: "A$",
};

export const HotelRoomList = ({ hotel, itinerary_details, cancelHotel, cancellation_details, booking_status, allowCancel,
    isBookedExpedia
}) => {

    const desc = hotel?.hotel_data?.property_description

    const expRooms = hotel?.rooms;
    const rooms = expRooms ? expRooms : convertObjArray(itinerary_details?.room_data);
    const cartJson = hotel?.cart;
    const cancellation = convertObjArray(cancellation_details);
    const policy = cancellation && cancellation.length > 0 ? cancellation[0] : null;
    const description = itinerary_details?.description;
    const voidDate = moment(policy?.date_before).format('MMM Do YYYY, h:mm a')
    const roomJson = cartJson?.items?.[0]?.room_json;

    // Extract pricing data from roomJson
    const occupancyPricing = roomJson?.occupancy_pricing;
    const occupancyKey = occupancyPricing ? Object.keys(occupancyPricing)[0] : null;
    const totals = occupancyPricing?.[occupancyKey]?.totals;

    // Calculate pricing breakdown
    const propertyFees = Number(totals?.property_fees?.request_currency?.value ?? 0);
    const baseRate = Number(totals?.exclusive?.request_currency?.value ?? 0);
    const totalCost = Number(totals?.inclusive?.request_currency?.value ?? 0);
    const taxesAndFees = totalCost - baseRate;
    const currencyCode = cartJson?.items?.[0]?.currency || "USD";
    const currencySymbol = currencySymbols[currencyCode] || "$";

    // Get rooms count from cartJson
    const roomsCount = parseInt(cartJson?.items?.[0]?.check_in_json?.rooms || 1);
    const checkIn = cartJson?.items?.[0]?.check_in;
    const checkOut = cartJson?.items?.[0]?.check_out;
    const nights = checkIn && checkOut ? moment(checkOut).diff(moment(checkIn), 'days') : 0;

    // Calculate totals
    const taxesAndFeesTotal = taxesAndFees * roomsCount;
    const totalCostTotal = totalCost * roomsCount;
    const propertyFeesTotal = propertyFees * roomsCount;
    const allInTotal = totalCostTotal + propertyFeesTotal;

    // Get checkInfo for property fees tooltip
    const checkInfo = cartJson?.items?.[0]?.check_in_json?.muvHotel?.checkInfo;

    const itineraryNumber = hotel?.itinerary_id;

    return (
        <div style={{ width: "100%" }}>
            <div style={{ padding: "10px 12%", marginBottom: 15 }}>
                <div style={{ color: '#FB884D', font: "22px/22px Futura Md BT", marginBottom: 30, lineHeight: "40px" }}>
                    Room Details
                    {desc && <div style={{ color: '#707070', font: "18px/18px Futura Lt BT", }}>
                        {desc}
                    </div>}
                </div>


                {/* Room Details - Show once with total count */}
                {rooms && rooms.length > 0 && (
                    <div style={{
                        color: '#707070', font: "18px/18px Futura Lt BT",
                        lineHeight: "25px", marginBottom: 20,
                    }}>
                        <span style={{ color: '#0D3A7D', font: "22px/18px Futura Md BT", }}>
                            {rooms.length === 1 ? 'Room 1:' : `Room (1-${rooms.length}):`}
                        </span>
                        <span style={{ color: '#000000', font: "18px/18px Futura Md BT" }}>
                            &nbsp; {rooms[0]?.name}
                        </span>
                        <br />

                        {/* Add room details from cart JSON if available */}
                        {(() => {
                            try {
                                const roomInfo = cartJson?.items?.[0]?.check_in_json?.muvHotel?.roomInfo;
                                if (!roomInfo) return null;

                                return (
                                    <div style={{ marginTop: 10 }}>
                                        {/* Room Type */}
                                        {roomInfo.name && (
                                            <div style={{ marginBottom: 8 }}>

                                                <div style={{ marginTop: 5 }}>
                                                    {roomInfo.name}
                                                </div>
                                            </div>
                                        )}

                                        {/* Size */}
                                        {roomInfo.area?.square_feet && roomInfo.area?.square_meters && (
                                            <div style={{ marginBottom: 8 }}>

                                                <div style={{ marginTop: 5 }}>
                                                    {roomInfo.area.square_feet} sq ft ({roomInfo.area.square_meters} sq m)
                                                </div>
                                            </div>
                                        )}

                                        {/* Occupancy */}
                                        {roomInfo.occupancy?.max_allowed && (
                                            <div style={{ marginBottom: 8 }}>

                                                <div style={{ marginTop: 5 }}>
                                                    Max {roomInfo.occupancy.max_allowed.total || 0} guests
                                                    ({roomInfo.occupancy.max_allowed.adults || 0} adults,
                                                    {roomInfo.occupancy.max_allowed.children || 0} children)
                                                </div>
                                            </div>
                                        )}

                                        {/* Bed Configuration */}
                                        {roomInfo.bed_groups &&
                                            typeof roomInfo.bed_groups === 'object' &&
                                            Object.keys(roomInfo.bed_groups).length > 0 && (
                                                <div style={{ marginBottom: 8 }}>

                                                    <div style={{ marginTop: 5 }}>
                                                        {Object.values(roomInfo.bed_groups).map((bedGroup, bedIndex) => {
                                                            if (!bedGroup || typeof bedGroup !== 'object') return null;
                                                            return (
                                                                <div key={bedIndex} style={{ marginBottom: 5 }}>
                                                                    {bedGroup.description || 'Bed configuration not specified'}
                                                                </div>
                                                            );
                                                        }).filter(Boolean)}
                                                    </div>
                                                </div>
                                            )}

                                        {/* Fallback message if no room details available */}
                                        {(!roomInfo.name &&
                                            !roomInfo.descriptions?.overview &&
                                            !roomInfo.area &&
                                            !roomInfo.occupancy &&
                                            !roomInfo.bed_groups &&
                                            !roomInfo.amenities) && (
                                                <div style={{
                                                    marginBottom: 8,
                                                    fontStyle: 'italic',
                                                    color: '#999',
                                                    fontSize: '14px'
                                                }}>
                                                    Room details not available
                                                </div>
                                            )}
                                    </div>
                                );
                            } catch (error) {
                                console.error('Error rendering room details:', error);
                                return (
                                    <div style={{
                                        marginTop: 10,
                                        paddingLeft: 20,
                                        color: '#ff6b6b',
                                        fontSize: '14px',
                                        fontStyle: 'italic'
                                    }}>
                                        Unable to load room details
                                    </div>
                                );
                            }
                        })()}

                    </div>
                )}

                {/* Hotel-wide information sections - only appear once */}
                <div style={{ marginTop: 20 }}>
                    {/* Cancellation Policy */}
                    <div style={{ color: '#000000', font: "18px/18px Futura Md BT", paddingTop: 15, marginBottom: 10 }}>
                        Cancellation Policy:
                    </div>
                    {renderCancellationPolicy(hotel?.rooms?.[0]?.rate)}

                    {allowCancel && <div
                        style={{ color: '#707070', font: "18px/18px Futura Lt BT", paddingTop: 8, paddingBottom: 15 }}
                    >
                        {policy?.description}
                        &nbsp;
                        <a onClick={cancelHotel} style={{ color: "#0D3A7D", cursor: 'pointer', font: "18px/18px Futura Md BT" }}>(Cancel now)</a>
                    </div>}

                    <hr style={{ marginTop: 20, marginBottom: 20 }} />

                    {/* Price Summary */}
                    {roomJson?.occupancy_pricing && totals ? (
                        <div style={{ marginBottom: 20 }}>
                            <div style={{ color: '#000000', font: "18px/18px Futura Md BT", paddingTop: 15, marginBottom: 12 }}>
                                Price Summary:
                            </div>
                            <div style={{ marginTop: 8 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 15, color: '#707070', font: "16px/16px Futura Lt BT" }}>
                                    <span>Price ({roomsCount} room(s) x {nights} night(s)):</span>
                                    <span>{currencySymbol}{(baseRate * roomsCount).toFixed(2)}</span>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 15, color: '#707070', font: "16px/16px Futura Lt BT" }}>
                                    <span style={{ width: "12rem", display: "inline-block" }}>
                                        Taxes and Fees:
                                        <div style={{ marginLeft: -10, display: "inline-block" }}>
                                            <MuvInstructionsPopover text={"The taxes are tax recovery charges paid to vendors (e.g.,hotels); for details please see our Terms of Use. Service fees are retain as compensation in servicing your booking and may include fees charged by vendors"} />
                                        </div>
                                    </span>
                                    <span>{currencySymbol}{(taxesAndFeesTotal).toFixed(2)}</span>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, marginBottom: 15, color: 'var(--mainBlack)', font: "16px/16px Futura Lt BT" }}>
                                    <span style={{ font: "16px/16px Futura Md BT" }}>
                                        TOTAL<span style={{ font: "16px/16px Futura Lt BT" }}> (Pay now):</span>
                                    </span>
                                    <span style={{ font: "16px/16px Futura Md BT" }}>
                                        <span style={{ font: "13px/16px Futura Md BT" }}>{currencyCode}</span>{currencySymbol}{totalCostTotal.toFixed(2)}
                                    </span>
                                </div>

                                {propertyFees > 0 && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, marginBottom: 15, color: 'var(--mainBlack)', font: "16px/16px Futura Lt BT" }}>
                                        <span>
                                            Property Fees (due at the property):
                                            <div style={{ marginLeft: -10, display: "inline-block" }}>
                                                <MuvInstructionsPopover html={checkInfo?.fees?.mandatory}
                                                    htmlTitle="Property Fees"
                                                />
                                            </div>
                                        </span>
                                        <span style={{ textAlign: "right" }}>{currencySymbol}{(propertyFeesTotal).toFixed(2)}</span>
                                    </div>
                                )}

                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10, marginBottom: 15, color: 'var(--mainBlack)', font: "16px/16px Futura Lt BT" }}>
                                    <span style={{ font: "16px/16px Futura Md BT" }}>
                                        Your total cost <span style={{ font: "16px/16px Futura Lt BT" }}>(inclusive of all taxes and fees):</span>
                                    </span>
                                    <span style={{ font: "16px/16px Futura Md BT" }}>
                                        <span style={{ font: "13px/16px Futura Md BT" }}>{currencyCode}</span>{currencySymbol}{allInTotal.toFixed(2)}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ) : cartJson?.items?.[0]?.price ? (
                        <div style={{ marginBottom: 20 }}>
                            <div style={{ color: '#000000', font: "18px/18px Futura Md BT", paddingTop: 15, marginBottom: 12 }}>
                                Price Summary:
                            </div>
                            <div style={{ marginTop: 8 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, color: '#707070', font: "18px/18px Futura Lt BT" }}>
                                    <span>Room Price:</span>
                                    <span style={{ fontWeight: 'bold' }}>
                                        {cartJson.items[0].currency || 'USD'} {parseFloat(cartJson.items[0].price).toFixed(2)}
                                    </span>
                                </div>
                                {cartJson?.items?.[0]?.check_in && cartJson?.items?.[0]?.check_out && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, color: '#707070', font: "18px/18px Futura Lt BT" }}>
                                        <span>Nights:</span>
                                        <span>{moment(cartJson.items[0].check_out).diff(moment(cartJson.items[0].check_in), 'days')}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : null}

                    {/* Instructions */}
                    {cartJson?.items?.[0]?.check_in_json?.muvHotel?.checkInfo?.checkin?.instructions && (
                        <div style={{ marginBottom: 20 }}>
                            <div style={{ color: '#000000', font: "18px/18px Futura Md BT", paddingTop: 15, marginBottom: 12 }}>
                                Instructions:
                            </div>
                            <div
                                style={{ marginTop: 8, color: '#707070', font: "18px/18px Futura Lt BT", lineHeight: '24px' }}
                                dangerouslySetInnerHTML={{
                                    __html: cartJson.items[0].check_in_json.muvHotel.checkInfo.checkin.instructions
                                }}
                            />
                        </div>
                    )}

                    {/* Special Instructions */}
                    {cartJson?.items?.[0]?.check_in_json?.muvHotel?.checkInfo?.checkin?.special_instructions && (
                        <div style={{ marginBottom: 20 }}>
                            <div style={{ color: '#000000', font: "18px/18px Futura Md BT", paddingTop: 15, marginBottom: 12 }}>
                                Special Instructions:
                            </div>
                            <div style={{ marginTop: 8, color: '#707070', font: "18px/18px Futura Lt BT", lineHeight: '24px' }}>
                                {cartJson.items[0].check_in_json.muvHotel.checkInfo.checkin.special_instructions}
                            </div>
                        </div>
                    )}

                    {/* Optional Fees */}
                    {cartJson?.items?.[0]?.check_in_json?.muvHotel?.checkInfo?.fees?.optional && (
                        <div style={{ marginBottom: 20 }}>
                            <div style={{ color: '#000000', font: "18px/18px Futura Md BT", paddingTop: 15, marginBottom: 12 }}>
                                Optional Fees:
                            </div>
                            <div
                                style={{ marginTop: 8, color: '#707070', font: "18px/18px Futura Lt BT", lineHeight: '24px' }}
                                dangerouslySetInnerHTML={{
                                    __html: cartJson.items[0].check_in_json.muvHotel.checkInfo.fees.optional
                                }}
                            />
                        </div>
                    )}

                    {/* Children and Extra Beds */}
                    {cartJson?.items?.[0]?.check_in_json?.muvHotel?.checkInfo?.checkin?.min_age && (
                        <div style={{ marginBottom: 20 }}>
                            <div style={{ color: '#000000', font: "18px/18px Futura Md BT", paddingTop: 15, marginBottom: 12 }}>
                                Children and Extra Beds:
                            </div>
                            <div style={{ marginTop: 8, color: '#707070', font: "18px/18px Futura Lt BT", lineHeight: '24px' }}>
                                <div style={{ marginBottom: 5 }}>Children are welcome</div>
                                <div>Minimum age for check-in: {cartJson.items[0].check_in_json.muvHotel.checkInfo.checkin.min_age} years</div>
                            </div>
                        </div>
                    )}

                    {/* Guarantee Policy - Only show if data exists */}
                    {cartJson?.items?.[0]?.check_in_json?.muvHotel?.checkInfo?.guarantee_policy && (
                        <div style={{ marginBottom: 20 }}>
                            <div style={{ color: '#000000', font: "18px/18px Futura Md BT", paddingTop: 15, marginBottom: 12 }}>
                                Guarantee Policy:
                            </div>
                            <div
                                style={{ marginTop: 8, color: '#707070', font: "18px/18px Futura Lt BT", lineHeight: '24px' }}
                                dangerouslySetInnerHTML={{
                                    __html: cartJson.items[0].check_in_json.muvHotel.checkInfo.guarantee_policy
                                }}
                            />
                        </div>
                    )}

                    {/* Pre-pay Policy - Only show if data exists */}
                    {cartJson?.items?.[0]?.check_in_json?.muvHotel?.checkInfo?.prepay_policy && (
                        <div style={{ marginBottom: 20 }}>
                            <div style={{ color: '#000000', font: "18px/18px Futura Md BT", paddingTop: 15, marginBottom: 12 }}>
                                Pre-pay Policy:
                            </div>
                            <div
                                style={{ marginTop: 8, color: '#707070', font: "18px/18px Futura Lt BT", lineHeight: '24px' }}
                                dangerouslySetInnerHTML={{
                                    __html: cartJson.items[0].check_in_json.muvHotel.checkInfo.prepay_policy
                                }}
                            />
                        </div>
                    )}

                    {/* Customer Service - Only show if data exists */}
                    {cartJson?.items?.[0]?.check_in_json?.muvHotel?.checkInfo?.customer_service && (
                        <div style={{ marginBottom: 20 }}>
                            <div style={{ color: '#000000', font: "18px/18px Futura Md BT", paddingTop: 15, marginBottom: 12 }}>
                                Hotel Customer Service:
                            </div>
                            <div
                                style={{ marginTop: 8, color: '#707070', font: "18px/18px Futura Lt BT", lineHeight: '24px' }}
                                dangerouslySetInnerHTML={{
                                    __html: cartJson.items[0].check_in_json.muvHotel.checkInfo.customer_service
                                }}
                            />
                        </div>
                    )}

                    {/* Notice - Only show if data exists */}
                    {cartJson?.items?.[0]?.check_in_json?.muvHotel?.checkInfo?.notice && (
                        <div style={{ marginBottom: 20, padding: '15px', backgroundColor: '#fff3cd', borderRadius: '6px', border: '1px solid #ffeaa7' }}>
                            <div style={{ color: '#856404', font: "18px/18px Futura Md BT", marginBottom: 10 }}>
                                Notice:
                            </div>
                            <div
                                style={{ marginTop: 8, fontSize: '14px', color: '#856404', font: "18px/18px Futura Lt BT", lineHeight: '20px' }}
                                dangerouslySetInnerHTML={{
                                    __html: cartJson.items[0].check_in_json.muvHotel.checkInfo.notice
                                }}
                            />
                        </div>
                    )}

                    {/* Customer Service Section */}
                    {cartJson?.items?.[0]?.check_in_json?.muvHotel?.checkInfo?.phone && (
                        <div style={{ marginBottom: 20 }}>
                            <div style={{ color: '#000000', font: "18px/18px Futura Md BT", paddingTop: 15, marginBottom: 12 }}>
                                Hotel Customer Service:
                            </div>
                            <div style={{ marginTop: 8, color: '#707070', font: "18px/18px Futura Lt BT", lineHeight: '24px' }}>
                                <div style={{ marginBottom: 8 }}>Contact: {cartJson.items[0].check_in_json.muvHotel.checkInfo.phone}</div>

                            </div>
                        </div>
                    )}

                    {/* MuvTravel Customer Service Section */}
                    {cartJson?.items?.[0]?.check_in_json?.muvHotel?.checkInfo?.phone && (
                        <div style={{ marginBottom: 20 }}>
                            <div style={{ color: '#000000', font: "18px/18px Futura Md BT", paddingTop: 15, marginBottom: 12 }}>
                                müvTravel Customer Service:
                            </div>
                            <div style={{ marginTop: 8, color: '#707070', font: "18px/18px Futura Lt BT", lineHeight: '24px' }}>
                                <div style={{ marginBottom: 8 }}>Itinerary Number: {itineraryNumber}</div>
                                <div style={{ marginBottom: 8 }}>Toll Free: +1-800-230-0925</div>
                                <div style={{ marginBottom: 8 }}>International: +1-417-520-1687</div>


                            </div>
                        </div>
                    )}

                    <div style={{ fontSize: '14px', color: '#666', marginTop: 5, lineHeight: '20px' }}>
                        Have your Trip Number and the phone number used during reservation available when calling
                    </div>


                </div>


            </div>
        </div>
    )
}

export const convertObjArray = (data) => {
    if (data && Object.keys(data).length > 0) {
        var myData = Object.keys(data).map(key => {
            return data[key];
        })
        return myData
    }
    return []
}

const renderCancellationPolicy = (rate) => {
    try {
        const policy = rate?.cancel_penalties;
        const refund = rate?.cancel_refund;

        if (!Array.isArray(policy) || policy.length === 0) return null;

        const item = policy[0];
        const start = item?.start;
        const end = item?.end;
        const currency = item?.currency || "USD";

        const startMoment = moment(start);
        const endMoment = moment(end);

        if (!startMoment.isValid() || !endMoment.isValid()) return null;

        // Get user's local timezone abbreviation
        const getUserTimezoneAbbr = (date) => {
            const formatOptions = { timeZoneName: "short" };
            const formatter = new Intl.DateTimeFormat(undefined, formatOptions);
            const parts = formatter.formatToParts(date.toDate());
            const tzPart = parts.find((part) => part.type === "timeZoneName");
            return tzPart ? tzPart.value : "";
        };

        const abbr = getUserTimezoneAbbr(startMoment);
        const hasPassed = startMoment.isBefore(moment());
        const cancelUntil = `${startMoment.format("MMMM Do [@] h:mm A")} ${abbr}${hasPassed ? " (date passed)" : ""
            }`;

        const penaltyWindow = `${startMoment.format("MMMM Do")} to ${endMoment.format("MMMM Do")}`;
        const refundAmount = refund?.amount ? parseFloat(refund.amount).toFixed(2) : null;

        return (
            <div
                style={{

                    paddingTop: 20,
                    paddingBottom: 10,
                    color: "var(--mainGrey)",
                    font: "18px/20px Futura Lt BT",
                }}
            >
                {!rate?.refundable ? (
                    <span>This rate is non-refundable.</span>
                ) : (
                    <>
                        <span>
                            Free cancellation until <strong>{cancelUntil}</strong>.
                        </span>
                        {refundAmount && (
                            <span>
                                After that, a cancellation fee of <strong>{currency} {Math.abs(refundAmount)}</strong> applies.
                            </span>
                        )}
                        <div>Penalty window: <strong>{penaltyWindow}</strong>.</div>
                    </>
                )}
            </div>
        );
    } catch (err) {
        console.error("Error rendering cancellation policy:", err);
        return null;
    }
};
